import { styled } from '@linaria/react'

export const HomeBlockWrapper = styled.section`
  position: relative;
  padding: 6rem 0 3rem;
  background-color: ${props => props.background};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--size-lg);
  height: 100%;
  min-height: 100vh;

  > :last-of-type {
    margin-top: auto;
  }

  > .is-root-container {
    position: relative;
    z-index: 3;
  }

  .block-editor & {
    min-height: calc(100vh - 5rem);
  }

  .title {
    position: relative;
    margin-bottom: 5rem;
    z-index: 1;

    h1 {
      font-weight: var(--font-weight-bolder);
      letter-spacing: -0.1rem;
      max-width: 50%;
      margin: 0;
      padding: 0;
      color: var(--white);
    }
  }

  .block-editor-inner-blocks,
  .home-stage__content {
    .icon-box {
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      box-shadow: none;
      border-radius: 0;
      background: transparent;
      padding: 1rem 0;
      max-width: 13rem;

      &__icon {
        flex-shrink: 0;
        display: block;
        height: 3.2rem;
        width: 3.2rem;
      }

      svg {
        &.bg {
          display: none;
        }

        path {
          fill: var(--leinen);
        }
      }

      &__title {
        text-align: left;
        transition: color 0.2s;
        color: var(--leinen);
      }

      &.with-link {
        &:hover {
          svg {
            path {
              fill: var(--leaf);
            }
          }
          p {
            color: var(--leaf);
          }
        }
      }
    }
  }

  .home-stage {
    &__content {
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: baseline;
      z-index: 1;
    }
    &__image {
      position: absolute;
      right: 0;
      bottom: 6.5rem;
      z-index: 2;
      max-width: 50%;
    }
  }

  .player-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    iframe,
    video {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      min-width: 100%;
      min-height: 100%;
      pointer-events: none;
    }
  }

  @media (min-width: 1550px) {
    padding: 23vh 0 4.5rem;
    height: 100vh;

    .title {
      position: relative;
      margin-bottom: 10rem;
      z-index: 1;

      h1 {
        font-size: 6rem;
        line-height: 0.95;
      }
    }
  }

  @media (max-width: 1025px) {
    .title {
      margin-bottom: 2rem;

      h1 {
        font-size: 4rem;
        line-height: 1;
      }
    }

    .home-stage {
      &__image {
        max-width: 40%;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 9rem 0 3rem;

    .title {
      margin-bottom: 1.5rem;

      h1 {
        font-size: 2.5rem;
        letter-spacing: -0.05rem;
        max-width: 100%;
      }
    }

    .home-stage {
      &__content {
        gap: 1rem;

        .icon-box {
          padding: 0.5rem 0;
          max-width: 45%;
          width: 100%;

          &__icon {
            display: inline-block;
            height: 2.5rem;
            width: 2.5rem;
            margin-bottom: 0;
          }
        }
      }
      &__image {
        position: relative;
        bottom: 0;
        z-index: 1;
        align-self: flex-end;
        max-width: 50%;
        margin-bottom: 1rem;
      }
    }
  }
`
